import axios from "axios";
import {APIServer, appVersion} from "@/constants/config";

const moment = require('moment');

export async function checkServerVersion() {
  const response = await axios.get(APIServer + "/version");
  return String(response.data) === appVersion;
}

export function isExternalUser() {
  try {
    if (localStorage.getItem('currentUser') !== null && localStorage.getItem('currentUser').length > 0) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'))
      const {role} = currentUser
      const {isSale, isStudent, type} = role
      return isSale || isStudent || type === 'lawyer' || type === 'legalCounsel'
    }

    return false
  } catch (e) {
    // console.log(e);
    return true;
  }
}

export function isRoot() {
  try {
    if (localStorage.getItem('currentUser') !== null && localStorage.getItem('currentUser').length > 0) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'))
      const {role} = currentUser
      const {isRoot} = role
      return isRoot
    }
    return false
  } catch (e) {
    // console.log(e);
    return false
  }
}

export function isLawyer() {
  try {
    if (localStorage.getItem('currentUser') !== null && localStorage.getItem('currentUser').length > 0) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'))
      const {role} = currentUser
      const {type} = role
      return type === 'lawyer'
    }
    return false
  } catch (e) {
    // console.log(e);
    return false
  }
}

export function isLegalCounsel() {
  try {
    if (localStorage.getItem('currentUser') !== null && localStorage.getItem('currentUser').length > 0) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'))
      const {role} = currentUser
      const {type} = role
      return type === 'legalCounsel'
    }
    return false
  } catch (e) {
    // console.log(e);
    return false
  }
}

export const round = (number, decimalPlaces) => {
  if (!number) {
    return 0;
  }
  if (number < 0) {
    return number;
  }
  const pow = 1000;
  const factorOfTen = Math.pow(10, decimalPlaces);
  number = number * pow;
  return Math.round((number * factorOfTen) / pow) / factorOfTen;
}

export const momentSet = {
  zeroTime: {
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  limitTime: {
    hour: 23,
    minute: 59,
    second: 59,
    millisecond: 999,
  },
};

export const getReportDate = (fixed = 0) => {
  let currentDate = moment();
  const dd = parseInt(currentDate.format('DD'));
  if (dd <= 5) {
    fixed++
  }
  currentDate.add(-fixed, "months")
  return {
    year: parseInt(currentDate.format("YYYY")),
    month: parseInt(currentDate.format("MM")),
    day: parseInt(currentDate.format("DD"))
  }
};

export const checkMaximumReportDate = (year, month, fixed = 0) => {
  let currentDate = moment();
  const dd = parseInt(currentDate.format('DD'));
  currentDate.set({'year': year, 'month': month - 1, 'date': 1});
  if (dd <= 5) {
    fixed++
  }
  const maximumDate = moment().add(-fixed, 'months').endOf("month")
  const check = (currentDate.set(momentSet.zeroTime).isSameOrBefore(maximumDate.set(momentSet.zeroTime)))
  if (!check) {
    alert("กรุณาตรวจสอบรอบรายงาน โดยจะสามารถเรียกรายงานรอบปัจจุบันได้ตั้งแต่วันที่ 6 เป็นต้นไป")
  }
  return check
};

export const isLastDay = function (date) {
  let nowDay = new Date(date.getTime());
  nowDay.setDate(nowDay.getDate() + 1);
  return nowDay.getDate() === 1;
}

export const getLastDay = function (date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0)
}

export const mRound = (number, multiple) => {
  if (multiple === 0) return 0;
  return Math.round(number / multiple) * multiple;
}

export const numberFormat = (number) => {
  if (!number) {
    return '0.00';
  }
  if (isNaN(parseInt(number))) {
    return '0.00';
  }
  if (number < 0) {
    return '0.00';
  }
  number = round(number, 2)
  const parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (!parts[1]) parts[1] = "00"
  else parts[1] = (parts[1].length === 1 ? `${parts[1]}0` : parts[1])
  return parts.join(".");
}
